module.exports = __webpack_public_path__ + "img/customization.78e80a39.png";